module.exports = __webpack_public_path__ + "static/media/share.7d3474f4.png";